export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

// This is a deliberately small denylist for the passwords attackers try
// first. It is not presented as a full breach corpus; the server can later
// add a privacy-preserving breach lookup without changing form contracts.
const COMMON_PASSWORDS = new Set([
	'123456', '12345678', '123456789', '1234567890', 'password', 'password1', 'password123',
	'qwerty', 'qwerty123', 'abc123', 'letmein', 'welcome', 'iloveyou', 'admin', 'administrator',
	'football', 'monkey', 'dragon', 'sunshine', 'princess', 'login', 'deepmox',
]);

function lengthOf(value: string): number {
	// Match HTML maxlength and JavaScript String.length so the browser,
	// SPA validators, lazy credential modals and Worker share one unit.
	return value.length;
}

export function validateNewPassword(value: string): string | null {
	const length = lengthOf(value);
	if (length < PASSWORD_MIN_LENGTH) return `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`;
	if (length > PASSWORD_MAX_LENGTH) return `Password must be at most ${PASSWORD_MAX_LENGTH} characters.`;
	if (COMMON_PASSWORDS.has(value.normalize('NFKC').toLocaleLowerCase('en-US'))) return 'Choose a less common password.';
	return null;
}

export function validateCurrentPassword(value: string): string | null {
	if (lengthOf(value) < 1) return 'Please enter your password.';
	if (lengthOf(value) > PASSWORD_MAX_LENGTH) return `Password must be at most ${PASSWORD_MAX_LENGTH} characters.`;
	return null;
}
